import React, { useState, useEffect } from "react";
import JsonData from "../data/data.json";
import { Header } from "../components/header";
import { Navigation } from "../components/navigation";
import { Services } from "../components/services";
import { Contact } from "../components/contact";

const PublicacionesPage = () => {
  const [data, setData] = useState({});
  useEffect(() => {
    setData(JsonData);
  }, []);
  return (
    <>
      <Header />
      <Navigation />
      <Services data={data.Services} />
      <Contact data={data.Contact} />
    </>
  );
};

export default PublicacionesPage;
